@if(isNativeApp){
  <ng-container>
    @if(isLoading()){
      <ion-spinner name="crescent" ></ion-spinner>
    } @else {
      <div class="barcode-scanner">
        @if(scanResult() && displayResult){
          <ion-text
            color="success"
            class="scan-result"><p>Scanned: {{ scanResult() }}</p>
          </ion-text>
        }
        @if (scanError()) {
          <ion-text
            color="danger"
          class="scan-result" innerHTML="{{ scanError() }}"></ion-text>
        }
        <ion-button
          fill="clear"
          shape="round"
          size="default"
          (click)="startScanning()"
          [disabled]="isScanning()"
          class="scan-button"
          title="Scan barcode or QR code"
          >
          <ion-icon size="small" slot="icon-only" name="qr-code-outline"></ion-icon>
        </ion-button>
      </div>
    }
  </ng-container>
}
